const selectors = {
  block: "[data-hb2c]",
  anchor: "[data-hb2c-anchor]",
  item: "[data-hb2c-item]",
};

const highlightLink = (que, anchors) => {
  anchors.forEach((anchor) => {
    const isActive = anchor.href.includes(que[0]);

    anchor.setAttribute("data-hb2c-anchor", isActive ? "active" : "");
  });
};

const observeItems = (items, anchors) => {
  let que = [];

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        que = que.filter((id) => id !== entry.target.id);
      } else {
        que = [...que, entry.target.id];

        highlightLink(que, anchors);
      }
    },
    {
      threshold: 1,
    }
  );

  items.forEach((item) => observer.observe(item));
};

const initBlock = (block) => {
  const anchors = block.querySelectorAll(selectors.anchor);
  const items = block.querySelectorAll(selectors.item);

  observeItems(items, anchors);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
